import { CancelTravelFormValues } from '../cancelTravelForm.types';

export function mapInitialValuesTravelCancellation(): CancelTravelFormValues {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return {
    cancelReason: undefined,
    futureCancelDate: undefined,
  };
}
